import React from 'react';
import './OffersLoading.css';

/**
 * OffersLoading — shimmer skeletons matching OfferCard layout.
 */
export default function OffersLoading({ count = 4 }) {
  const items = Array.from({ length: count });
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="offers-loading"
    >
      <span className="offers-sr-only">Loading offers…</span>
      {items.map((_, i) => (
        <div key={i} className="offers-loading__card" aria-hidden="true">
          <div className="offers-loading__strip">
            <span className="offers-loading__shimmer offers-loading__pill" />
            <span className="offers-loading__shimmer offers-loading__pill" />
            <span className="offers-loading__shimmer offers-loading__pill offers-loading__pill--right" />
          </div>
          <div className="offers-loading__shimmer offers-loading__address" />
          <div className="offers-loading__shimmer offers-loading__price" />
          <div className="offers-loading__kv">
            <div className="offers-loading__shimmer offers-loading__kv-cell" />
            <div className="offers-loading__shimmer offers-loading__kv-cell" />
            <div className="offers-loading__shimmer offers-loading__kv-cell" />
          </div>
          <div className="offers-loading__actions">
            <div className="offers-loading__shimmer offers-loading__btn" />
            <div className="offers-loading__shimmer offers-loading__btn-sm" />
          </div>
        </div>
      ))}
    </div>
  );
}
